<div class="table-container">
  <mat-table [dataSource]="dataSource" matSort>
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? rowToggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)"
        >
        </mat-checkbox>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef [attr.colspan]="4">
        <mat-form-field *ngIf="dataSource.data.length > 0" style="width: 100%">
          <mat-label>{{ "COURSES.LISTS.FILTER" | translate }}</mat-label>
          <input
            matInput
            (keyup)="applyFilter($event)"
            placeholder="John Doe Pérez"
            #input
          />
        </mat-form-field>
      </mat-footer-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="table-head">
        {{ "COURSES.LISTS.NAME" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <!-- First and Second Last Name Column -->
    <ng-container matColumnDef="lastNames">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="table-head">
        {{ "COURSES.LISTS.LASTNAME" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.firstLastName + " " + element.secondLastName }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>
    <!-- color group -->
<!--     <ng-container matColumnDef="group">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="table-head">
        <!-- {{ 'COURSES.LISTS.ROLE' | translate}}-->
     <!--   grupos
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-form-field appearance="fill">
          <mat-label>{{element.color}}</mat-label>
          <mat-select (selectionChange)="someMethod($event.value, element)">
            <mat-option *ngFor="let color of colorList" [value]="color">
              {{ color }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!--{{element.color}} -->
     <!-- </mat-cell>
      <mat-footer-cell *matFooterCellDef>
        
      </mat-footer-cell>
    </ng-container> -->

    <!-- Email Column -->
    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="table-head">
        {{ "COURSES.LISTS.EMAIL" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.email }} </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>
    <!-- User-Org Relation -->
    <ng-container matColumnDef="role">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="table-head">
        {{ "COURSES.LISTS.ROLE" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.orgRelationship }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
    ></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    <mat-footer-row
      *matFooterRowDef="displayedColumns; sticky: true"
    ></mat-footer-row>

    <!-- Row shown when there is no matching data. -->
    <mat-row class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No se encuentran perfiles</td>
    </mat-row>
  </mat-table>
</div>
